import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useSelector } from "react-redux";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = () => {

    const themeSstore = useSelector((state) => state.theme)
    const themeStyle =  themeSstore.theme

    const data = {
        labels: ["Allowed", "Pending", "Rejected"],
        datasets: [
            {
                label: "Declared vs Allowed",
                data: [85, 10, 5], // 👈 customize percentages or values
                backgroundColor: ["#7B61FF", "#F5A623", "#E74C3C"],
                borderWidth: 0,
                cutout: "50%", // inner hole size
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                position: "top",
                labels: {
                    color: themeStyle == "dark" ? "#ffffff" : "#000000",
                    usePointStyle: true,
                    pointStyle: "rect",
                    boxWidth: 50,
                    padding: 10,
                },
            },
            tooltip: {
                enabled: true,
                backgroundColor: themeStyle == "dark" ? "#1e1e2f" : "#ffffff",
                titleColor: themeStyle == "dark" ? "#fff" : "#000000",
                bodyColor: themeStyle == "dark" ? "#ddd" : "#000",
            },
        },
        layout: {
            padding: 10,
        },
    };

    return (
        <Doughnut data={data} options={options} />
    );
};

export default DoughnutChart;
